import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-databricks', 'BrandDatabricks', [["path",{"d":"M3 17l9 5l9 -5v-3l-9 5l-9 -5v-3l9 5l9 -5v-3l-9 5l-9 -5l9 -5l5.418 3.01"}]]);